var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.06836C12.8765 6.08031 12.7507 6.08748 12.6272 6.08748C11.2594 6.08748 9.98361 5.40631 9.23315 4.27581V10.4422C9.23315 12.9589 7.16574 15 4.61657 15C2.06741 15 0 12.9589 0 10.4422C0 7.92543 2.06741 5.88432 4.61657 5.88432C4.71341 5.88432 4.80782 5.89388 4.90223 5.89866V8.14532C4.80782 8.13337 4.71341 8.11664 4.61657 8.11664C3.31657 8.11664 2.26108 9.1587 2.26108 10.4422C2.26108 11.7256 3.31657 12.7677 4.61657 12.7677C5.91657 12.7677 7.06648 11.7543 7.06648 10.4708L7.08827 0H9.26462C9.47039 1.92639 11.0439 3.43212 13 3.57314V6.06836Z",
    fill: "#D19B16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredTiktok);
export default __webpack_public_path__ + "static/media/colored-tiktok.b018842a0815fb5b6fe03eceaa3a9b32.svg";
export { ForwardRef as ReactComponent };